import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { authService } from '../services/api';
import MarketingNav from '../components/layout/MarketingNav';
import { Button, Card, Input } from '../components/ui';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get('token'), [searchParams]);
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (!token) return;

    const verify = async () => {
      setStatus('verifying');
      try {
        const response = await authService.verifyEmail(token);
        setStatus('success');
        setMessage(response.data?.message || 'Email verified successfully.');
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.message || 'Verification failed.');
      }
    };

    verify();
  }, [token]);

  const handleResend = async (e) => {
    e.preventDefault();
    setStatus('resending');

    try {
      const response = await authService.resendVerification(email);
      setStatus('resent');
      setMessage(response.data?.message || 'Verification email sent.');
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.message || 'Failed to resend verification email.');
    }
  };

  return (
    <>
      <MarketingNav transparent={false} />
      <main className="flex min-h-screen items-center justify-center bg-neutral-50 px-6 py-12 mt-20">
        <Card className="w-full max-w-lg text-center">
        <h1 className="text-3xl font-semibold text-neutral-900">Verify your email</h1>
        <p className="mt-3 text-sm text-neutral-600">
          {token ? 'We are verifying your email address.' : 'Enter your email to resend the verification link.'}
        </p>

        {message && (
          <div className="mt-4 rounded-soft border border-neutral-200 bg-white p-3 text-sm text-neutral-700">
            {message}
          </div>
        )}

        {status === 'success' && (
          <Button
            size="lg"
            className="mt-6 w-full"
            onClick={() => window.location.href = '/login'}
          >
            Continue to login
          </Button>
        )}

        {(status !== 'success' || !token) && (
          <form onSubmit={handleResend} className="mt-6 space-y-4">
            <Input
              label="Email address"
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              fullWidth
            />
            <Button
              type="submit"
              size="lg"
              className="w-full"
              disabled={status === 'resending' || !email}
            >
              {status === 'resending' ? 'Sending…' : 'Resend verification email'}
            </Button>
          </form>
        )}
      </Card>
    </main>
    </>
  );
};

export default VerifyEmail;
